import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'
import EquipmentByDepartmentTable from '../EquipmentByDepartmentTable/equipmentByDepartmentTable.vue'
import RequestByDepartmentTable from '../RequestByDepartmentTable/requestByDepartmentTable.vue'
import TopFiveEquipmentFailures from '../TopFiveEquipmentFailures/topFiveEquipmentFailures.vue'
import SolicitedVConclued from '../SolicitedVConlued/solicitedVConclued.vue'
import InternalResolvability from '../InternalResolvability/internalResolvability.vue'
import PreventiveXCorrective from '../PreventiveXCorrective/preventiveXCorrective.vue'
import PreventiveScheduleXExecuted from '../PreventiveScheduleXExecuted/preventiveScheduleXExecuted.vue'
import CalibrationScheduleXExecuted from '../CalibrationScheduleXExecuted/calibrationScheduleXExecuted.vue'
import AlienatedEquipment from '../AlienatedEquipment/alienatedEquipment.vue'
import CorrectiveScheduleXExecuted from '../CorrectiveScheduleXExecuted/correctiveScheduleXExecuted.vue'
import HistoricalMigration from '../HistoricalMigration/historicalMigration.vue'
// import TasksByDepartament from "../TasksByDepartament/tasksByDepartament.vue";
import ElectricalSafetyScheduleXExceuted from '../ElectricalSafetyScheduleXExceuted/electricalSafetyScheduleXExceuted.vue'
import DefectSolutionPrevalence from '../DefectSolutionPrevalence/defectSolutionPrevalence.vue'
import StoppedEquipPendingType from '../StoppedEquipPendingType/stoppedEquipPendingType.vue'
import OrderByWorkshop from '../orderByWorkshop/orderByWorkshop.vue'
import ResponsibleServicesByWeek from '../ResponsibleServicesByWeek/responsibleServicesByWeek.vue'

import moment from 'moment'

export default {
  components: {
    OrderByWorkshop,
    DefectSolutionPrevalence,
    EquipmentByDepartmentTable,
    RequestByDepartmentTable,
    TopFiveEquipmentFailures,
    SolicitedVConclued,
    InternalResolvability,
    PreventiveXCorrective,
    PreventiveScheduleXExecuted,
    CalibrationScheduleXExecuted,
    CorrectiveScheduleXExecuted,
    AlienatedEquipment,
    HistoricalMigration,
    // TasksByDepartament,
    ElectricalSafetyScheduleXExceuted,
    StoppedEquipPendingType,
    ResponsibleServicesByWeek,
  },

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id
    this.getInstitutions()

    if (this.institution.userType > 1) {
      this.getUserUnidades()
    } else {
      this.getUnidades()
    }

    this.filter.institutionId = this.institutionId

    if (this.institution.userType == 5) {
      this.unidadeIds = [userLogged.unidadeId]
    }

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.setDates()

    this.getWorkshops()
  },

  data: () => ({
    institutionSearch: '',
    workshopSearch: '',
    unitySearch: '',
    institution: {},
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    menuStartDate: false,
    menuEndDate: false,
    startDate: null,
    endDate: null,
    minDate: null,
    page: 1,
    pageSize: 14,
    institutionId: null,
    institutions: [],
    unidadeIds: null,
    unidades: [],
    userLogged: {},
    workshopTypes: [
      { text: 'Engenharia Clínica', value: 0 },
      { text: 'Carpintaria', value: 1 },
      { text: 'Elétrica', value: 2 },
      { text: 'Hidráulica', value: 3 },
      { text: 'Climatização', value: 4 },
      { text: 'Gasoterapia', value: 5 },
      { text: 'Zeladoria', value: 6 },
      { text: 'Vidraçaria', value: 7 },
      { text: 'Mecânica', value: 8 },
      { text: 'Serralheria', value: 9 },
      { text: 'Predial Civil', value: 10 },
      { text: 'Pintura Predial', value: 11 },
      { text: 'Pintura Industrial', value: 12 },
    ],
    filter: {
      page: 1,
      pageSize: 14,
      institutionId: null,
      unidadeIds: [],
      workshops: [],
      startDate: null,
      endDate: null,
    },
    apiService: new ApiService(),
  }),

  methods: {
    removeWorkshop(item) {
      this.filter.workshops.splice(item, 1)
      this.filter.workshops = [...this.filter.workshops]
    },
    removeUnity(item) {
      this.unidadeIds.splice(item, 1)
      this.unidadeIds = [...this.unidadeIds]
    },
    getWorkshops() {
      this.apiService
        .get('workshop/' + this.institution.id)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/list')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch((err) => {})
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    filterTables() {
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.institutionId = this.institutionId
      this.filter.unidadeIds = this.unidadeIds

      this.setDates()

      this.$refs.defectSolutionPrevalence.filterProp = this.filter
      this.$refs.stoppedEquipPendingType.filterProp = this.filter
      this.$refs.requestTable.filterProp = this.filter
      this.$refs.equipTable.filterProp = this.filter
      this.$refs.topFiveTable.filterProp = this.filter
      this.$refs.solicitedVconcluedTable.filterProp = this.filter
      this.$refs.internalResolvabilityTable.filterProp = this.filter
      this.$refs.preventiveXCorrective.filterProp = this.filter
      this.$refs.preventiveScheduleXExecuted.filterProp = this.filter
      this.$refs.calibrationScheduleXExecuted.filterProp = this.filter
      this.$refs.alienatedEquipment.filterProp = this.filter
      this.$refs.correctiveScheduleXExecuted.filterProp = this.filter
      this.$refs.historicalMigration.filterProp = this.filter
      this.$refs.electricalSafetyScheduleXExceuted.filterProp = this.filter

      if (this.institution.departmentTypes.includes(1)) {
        this.$refs.orderByWorkshop.filterProp = this.filter
        this.$refs.orderByWorkshop.list()
      }

      this.$refs.responsibleServicesByWeek.fetchData()
      this.$refs.defectSolutionPrevalence.list()
      this.$refs.equipTable.list()
      this.$refs.requestTable.listRequestByDepartment()
      this.$refs.topFiveTable.listTopFiveEquipmentFailures()
      this.$refs.solicitedVconcluedTable.listSolicitedVConclued()
      this.$refs.internalResolvabilityTable.listInternalResolvability()
      this.$refs.preventiveXCorrective.listcorrentiveXPreventive()
      this.$refs.preventiveScheduleXExecuted.listpreventiveScheduleXExecuted()
      this.$refs.calibrationScheduleXExecuted.listcalibrationScheduleExecuted()
      this.$refs.alienatedEquipment.listalienatedEquipment()
      this.$refs.correctiveScheduleXExecuted.list()
      // this.$refs.tasksByDepartament.listtasksByDepartament();
      this.$refs.historicalMigration.listhistoricalMigration()
      this.$refs.stoppedEquipPendingType.list()
      this.$refs.electricalSafetyScheduleXExceuted.list()
    },

    reset() {
      if (this.institution.userType == 5) {
        this.unidadeIds = [this.userLogged.unidadeId]
      } else {
        this.unidadeIds = []
      }

      this.filter = {
        page: 1,
        pageSize: 14,
        institutionId: null,
        workshops: [],
        unidadeIds: [],
        startDate: null,
        endDate: null,
      }
      ;(this.startDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        1
      )
        .toISOString()
        .substr(0, 7)),
        (this.endDate = new Date().toISOString().substr(0, 7)),
        (this.filterStartDate = null)
      this.filterEndDate = null

      this.filterTables()
    },

    getFirstDayLastMonth(date) {
      return Utils.getFirstDayLastMonth(date)
    },

    getEndDayLastMonth(date) {
      return Utils.getEndDayLastMonth(date)
    },
  },
}
